import React from 'react';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import type { RetryBucket } from '../../types/traffic';
interface RetryDistributionChartProps {
  buckets: RetryBucket[];
}
const axisStyle = {
  fill: 'var(--muted-foreground)',
  fontSize: 11,
  fontFamily: 'Geist Mono'
};
export function RetryDistributionChart({
  buckets
}: RetryDistributionChartProps) {
  if (buckets.length === 0) {
    return <p className="py-10 text-center font-mono text-xs text-muted-foreground" data-id="element-421" data-mp="2cnp7rvo7eret">
        No retries recorded yet
      </p>;
  }
  return <div className="h-56 w-full sm:h-64" data-id="element-422" data-mp="2lqqbjpplk6fb">
      <ResponsiveContainer width="100%" height="100%" data-id="element-423" data-mp="2lpoosnz7xvhr">
        <BarChart data={buckets} margin={{
        top: 4,
        right: 8,
        bottom: 0,
        left: -16
      }} data-id="element-424" data-mp="2gqlthv91j3mz">
          <CartesianGrid stroke="var(--border)" strokeDasharray="3 3" vertical={false} data-id="element-425" data-mp="rc755c1xpis0" />
          <XAxis dataKey="bucket" tick={axisStyle} stroke="var(--border)" tickMargin={8} data-id="element-426" data-mp="re0eiz3xmh3p" />
          <YAxis tick={axisStyle} stroke="var(--border)" allowDecimals={false} data-id="element-427" data-mp="mfgtd0x5x9ce" />
          <Tooltip cursor={{
          fill: 'var(--muted)'
        }} contentStyle={{
          background: 'var(--popover)',
          border: '1px solid var(--border)',
          borderRadius: 10,
          fontSize: 12,
          color: 'var(--popover-foreground)'
        }} formatter={(value: number) => [value.toLocaleString(), 'Visitors']} data-id="element-428" data-mp="1n4wcx2z9gpdm" />
          <Bar dataKey="visitors" fill="var(--chart-5)" radius={[4, 4, 0, 0]} barSize={36} data-id="element-429" data-mp="25tb4pshek7fh" />
        </BarChart>
      </ResponsiveContainer>
    </div>;
}